import * as React from 'react';
import { Toggletip as Toggletip$1 } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';

const Toggletip = ({ message , className  })=>{
    const { getLabel  } = useIntl();
    const ariaLabel = getLabel('common.tooltip');
    return /*#__PURE__*/ React.createElement(Toggletip$1, {
        message: message,
        ariaLabel: ariaLabel,
        "data-t": "tooltip",
        className: className
    });
};

export { Toggletip };
//# sourceMappingURL=Toggletip.js.map
